// extracted by mini-css-extract-plugin
export var chevron = "_ks-3";
export var chevronRotated = "_ks-4";
export var image = "_ks-1";
export var imageContainer = "_ks-0";
export var shippingAddress = "_ks-2";